/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Tenantuserid2Inputs */

const en_entity_tenantuserid2 = /** @type {(inputs: Entity_Tenantuserid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tenant User ID`)
};

const de_entity_tenantuserid2 = /** @type {(inputs: Entity_Tenantuserid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mandanten-Benutzer-ID`)
};

/**
* | output |
* | --- |
* | "Tenant User ID" |
*
* @param {Entity_Tenantuserid2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_tenantuserid2 = /** @type {((inputs?: Entity_Tenantuserid2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Tenantuserid2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_tenantuserid2(inputs)
	return de_entity_tenantuserid2(inputs)
});
export { entity_tenantuserid2 as "entity_tenantUserId" }